export default class GetAsistenciaByPersonal {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal) {
    try {
      const result = await this.#repository.getAsistenciaByPersonal(idPersonal)
      return result
    } catch (error) {
      console.error('Error al obtener la asistencia por ID de personal:', error)
      throw error
    }
  }
}
